import * as style from './style.module.scss'
import * as React from 'react'
import { Dialog, DialogBackdrop } from 'reakit/Dialog'

export default function Modal(props) {
  // `sheetClassName` is an optional hook for callers that want to decorate the
  // dialog sheet (e.g. an entrance animation) without affecting other modals.
  // `showCloseButton` renders the legacy top-right dismiss control when true.
  const { children, sheetClassName, showCloseButton = false, ...dialog } = props

  return (
    <DialogBackdrop className={style.dialogBackdrop} {...dialog}>
      <Dialog
        className={`${style.dialog}${sheetClassName ? ` ${sheetClassName}` : ''}`}
        {...dialog}
        hideOnEsc
      >
        {showCloseButton ? (
          <button
            type='button'
            className={style.button}
            onClick={dialog.hide}
            aria-label='Close'
          >
            Close
          </button>
        ) : null}
        <div className={style.dialogContent}>{children}</div>
      </Dialog>
    </DialogBackdrop>
  )
}
